import axios from "axios";

export const bartlogin = axios.create({
  baseURL: "https://bartinst-user-service-prod.herokuapp.com/login",
});

export const bartkiln = axios.create({
  baseURL: "https://kiln.bartinst.com/kilns",
});
